module.exports = __webpack_public_path__ + "img/37.90045640.jpg";